import { FormControlLabel, RadioGroup as MuiRadioGroup, Radio } from "@mui/material";
import BoxLayout from "library/Layouts/BoxLayout/BoxLayout";
import PropTypes from "prop-types";
import { useCallback } from "react";

const RadioGroup = ({ value, options, renderItem, onSelect }) => {
  const handleSelect = useCallback((e) => onSelect(e.target.value), [onSelect]);

  return (
    <MuiRadioGroup className="gap-4" value={value} onChange={handleSelect}>
      {options.map((option) => (
        <BoxLayout key={option.value} className="d-flex flex-1 align-content-stretch pt-2">
          <FormControlLabel
            className="col-12"
            componentsProps={{ typography: { className: "w-100" } }}
            value={option.value}
            control={<Radio size="small" />}
            label={renderItem(option.data)}
          />
        </BoxLayout>
      ))}
    </MuiRadioGroup>
  );
};

RadioGroup.defaultProps = {
  value: null,
};

RadioGroup.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onSelect: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      // eslint-disable-next-line react/forbid-prop-types
      data: PropTypes.any,
    })
  ).isRequired,
  renderItem: PropTypes.func.isRequired,
};

export default RadioGroup;
